/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import BackIcon from "../images/back.png";
import "lineicons/dist/lineicons.css";
import { cn, getCustomizationValue, renderCurrency, showSuccessToast } from "src/lib/utils";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getArchivedInvoices, unArchiveInvoice } from "src/api/invoice";
import CustomDataTable from "src/components/CustomDataTable";
import { format } from "date-fns";
import CustomDropdown from "src/components/CustomDropdown";
import { Button } from "src/components/ui/button";
import { EllipsisIcon } from "src/svg";
import CustomConfirmDialog from "src/components/CustomConfirmDialog";
import SearchInput from "src/components/widgets/SearchInput";
import { useAuth } from "src/providers/AuthProvider";

const columns = (mutate, user) => [
	{
		name: cn(getCustomizationValue(user, "invoice_label", true), " No."),
		selector: (row) => row.invoice_id,
	},
	{
		name: cn(getCustomizationValue(user, "customer_label"), " Name"),
		selector: (row) => `${row.first_name} ${row.last_name}`,
		grow: 1.5,
	},
	{
		name: "Phone",
		selector: (row) => row.phone,
	},
	{
		name: "Total Amount",
		selector: (row) => row.total_amount,
		format: (row) => renderCurrency(row.total_amount),
	},
	{
		name: "Date Created",
		selector: (row) => row.created_at,
		format: (row) => format(new Date(row.created_at), "MMM dd, yyyy"),
	},
	{
		name: "Due Date",
		selector: (row) => row.due_date,
		format: (row) => format(new Date(row.due_date), "MMM dd, yyyy"),
	},
	{
		name: "Action",
		cell: (row) => (
			<CustomDropdown
				trigger={
					<Button variant="hover">
						<EllipsisIcon />
					</Button>
				}
				actions={[
					{
						label: (
							<CustomConfirmDialog
								trigger={<span>Unarchive {getCustomizationValue(user, "invoice_label", true)}</span>}
								mutateFn={() => mutate({ uuid: row.uuid })}
							/>
						),
					},
				]}
			/>
		),
		width: "100px",
	},
];

const ArchivedInvoices = () => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const search = searchParams.get("search");
	const page = searchParams.get("page") || 1;
	const limit = searchParams.get("limit") || 10;

	const { data, isLoading, refetch } = useQuery({
		queryKey: ["invoices", "archived", page, limit, search],
		queryFn: () => getArchivedInvoices({ page, limit, search }),
	});
	const { mutate } = useMutation(unArchiveInvoice, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			refetch();
		},
	});

	const invoices = data?.data?.data;
	const totalRow = data?.data?.total;

	return (
		<div className="pageWrapper">
			<div className="pageTop">
				<button className="mr-2 transparent-btn" onClick={() => navigate("..", { relative: "path" })}>
					<img src={BackIcon} />
				</button>
				<h2>Archived {getCustomizationValue(user, "invoice_label")}</h2>
			</div>
			<div className="innerContent">
				<div className="mb-2 inner-top !tw-justify-end">
					<SearchInput name="search" placeholder="Search..." />
				</div>

				<CustomDataTable columns={columns(mutate, user)} data={invoices} progressPending={isLoading} paginationTotalRows={totalRow} />
			</div>
		</div>
	);
};

export default ArchivedInvoices;
